export default "__VITE_ASSET__fbf2fab0__"